import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { ChipTheme } from './interfaces';

@Component({
  selector: 'fcom-chip',
  styleUrls: ['chip.component.scss'],
  templateUrl: 'chip.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChipComponent {
  readonly ChipTheme = ChipTheme;

  @Input()
  theme: ChipTheme = ChipTheme.DEFAULT;
}
